import { orientationChange } from '../utils/orientationChange';
import { isIE11 } from '../utils/helpers';

export function setupUsps() {
    const uspIconList = document.querySelector('.usp-icon-list');
    const uspList = document.querySelector('.usp-list');

    if (uspIconList && uspList) {
        function iconTransitionEnd(e) {
            const icon = e.currentTarget;
            const uspsModule = icon.closest('.module');

            if (uspsModule) {
                const uspsIcons = uspsModule.querySelectorAll('.usp-icon-list__icon-circle__left');
                const uspsTexts = uspsModule.querySelectorAll('.usp-list__item');

                const currentActiveIndex = Array.from(uspsIcons).indexOf(icon);
                const nextActiveIndex = currentActiveIndex + 1 < uspsIcons.length ? currentActiveIndex + 1 : 0;

                uspsIcons[currentActiveIndex].removeEventListener('transitionend', iconTransitionEnd);
                uspsIcons[currentActiveIndex].closest('.usp-icon-list__item').classList.remove('js-active');
                uspsTexts[currentActiveIndex].classList.remove('js-active');

                uspsIcons[nextActiveIndex].addEventListener('transitionend', iconTransitionEnd);
                uspsIcons[nextActiveIndex].closest('.usp-icon-list__item').classList.add('js-active');
                uspsTexts[nextActiveIndex].classList.add('js-active');
            }
        }

        function onChange(changes, observer) {
            changes.forEach(change => {
                const uspModule = change.target.closest('.module');
                const uspsIcons = uspModule.querySelectorAll('.usp-icon-list__icon-circle__left');
                const uspsTexts = uspModule.querySelectorAll('.usp-list__item');
                const activeIcons = Array.from(uspsIcons).filter(x => x.closest('.usp-icon-list__item').classList.contains('js-active'));

                if (change.intersectionRatio > 0.1) {
                    if (activeIcons.length == 1) {
                        const currentActiveIndex = Array.from(uspsIcons).indexOf(activeIcons[0]);
                        const nextActiveIndex = currentActiveIndex + 1 < uspsIcons.length ? currentActiveIndex + 1 : 0;

                        uspsIcons[currentActiveIndex].removeEventListener('transitionend', iconTransitionEnd);
                        uspsIcons[currentActiveIndex].closest('.usp-icon-list__item').classList.remove('js-active');
                        uspsTexts[currentActiveIndex].classList.remove('js-active');

                        uspsIcons[nextActiveIndex].addEventListener('transitionend', iconTransitionEnd);
                        uspsIcons[nextActiveIndex].closest('.usp-icon-list__item').classList.add('js-active');
                        uspsTexts[nextActiveIndex].classList.add('js-active');
                    } else {
                        uspsIcons[0].addEventListener('transitionend', iconTransitionEnd);
                        uspsIcons[0].closest('.usp-icon-list__item').classList.add('js-active');
                    }
                } else {
                    Array.from(uspsIcons).forEach(uspsIcon => {
                        uspsIcon.removeEventListener('transitionend', iconTransitionEnd);
                    });
                }
            });
        }

        function setUspTextsHeight() {
            const uspsTexts = uspList.querySelectorAll('.usp-list__item');
            let height = 0;

            uspsTexts.forEach(uspText => {
                if (uspText.scrollHeight > height) {
                    height = uspText.scrollHeight;
                }
            });

            uspsTexts.forEach(uspText => {
                uspText.style.height = `${height}px`;
            });
        }

        if (!isIE11) {
            const config = {
                root: null,
                rootMargin: '0px',
                threshold: [0.1]
            };

            const observer = new IntersectionObserver(onChange, config);
            observer.observe(uspIconList);

            setUspTextsHeight();

            orientationChange(() => {
                setUspTextsHeight();
            });
        } else {
            Array.from(uspsModules).forEach(uspModule => {

            });
        }
    }
}